import React from "react";
import styles from "./Slide3.module.scss";
import { useIntl } from "react-intl";
import { messages } from "../../../Preparations.messages";
import * as appConfig from "appConfig";
import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";

export const Slide3: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.slide3}>
      <h2 className={styles.title}>{formatMessage(messages.softwareRequirementsSlide3Title)}</h2>
      <div className={styles.content}>
        <p>{formatMessage(messages.softwareRequirementsSlide3Description1)}</p>
        <div className={styles.carouselContainer}>
          {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
          <SpatialCarousel showBreadcrumbs>
            {[
              <div key="1" className={styles.imageContainer}>
                <img
                  style={{ height: "auto", width: "100%" }}
                  className={styles.image}
                  src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/8.png`}
                />
                <p className={styles.imageDescription}>{formatMessage(messages.softwareRequirementsSlide3Image1)}</p>
              </div>,
              <div key="2" className={styles.imageContainer}>
                <img
                  style={{ height: "auto", width: "100%" }}
                  className={styles.image}
                  src={`${appConfig.STATIC_ASSETS_URL}/lms/guide/guide03/preparations/9.png`}
                />
                <p className={styles.imageDescription}>{formatMessage(messages.softwareRequirementsSlide3Image2)}</p>
              </div>,
            ]}
          </SpatialCarousel>
        </div>
      </div>
    </div>
  );
};
